import React, { useState, useEffect, useRef } from 'react';

function CountUp({ target, suffix = '', prefix = '', decimals = 0, start }) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!start) return;
    let cur = 0;
    const inc = target / 55;
    const t = setInterval(() => {
      cur += inc;
      if (cur >= target) { setVal(target); clearInterval(t); }
      else setVal(parseFloat(cur.toFixed(decimals)));
    }, 25);
    return () => clearInterval(t);
  }, [start, target, decimals]);
  return <>{prefix}{val.toLocaleString()}{suffix}</>;
}

const STATS = [
  { num: 500, suffix: '+', label: 'Stores Powered', sub: 'Across retail, food, grocery & fashion' },
  { num: 1, suffix: 'M+', label: 'Orders Processed', sub: 'POS, mobile, delivery & bulk orders' },
  { num: 99.9, suffix: '%', label: 'Uptime Reliability', sub: 'Enterprise-grade infrastructure', decimals: 1 },
  { num: 24, suffix: ' hrs', label: 'Go-Live Time', sub: 'From setup to first live order' },
];

export default function Stats() {
  const ref = useRef(null);
  const [started, setStarted] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setStarted(true); obs.disconnect(); } }, { threshold: 0.3 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section style={{ background: 'linear-gradient(135deg,#0c1220 0%,#1e2d45 100%)', padding: '80px 0', position: 'relative', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', width: 800, height: 400, borderRadius: '50%', background: 'radial-gradient(circle,rgba(37,99,235,0.08) 0%,transparent 70%)', pointerEvents: 'none' }} />
      <div className="container" ref={ref}>
        <div style={{ textAlign: 'center', marginBottom: 52 }}>
          <h2 style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: 'clamp(28px,3.5vw,42px)', fontWeight: 800, color: 'white', letterSpacing: '-1px', marginBottom: 10 }}>Trusted by growing retailers</h2>
          <p style={{ fontSize: 16, color: 'rgba(255,255,255,0.45)' }}>Numbers that reflect real business impact</p>
        </div>
        <div className="g4">
          {STATS.map((s, i) => (
            <div key={i} style={{ textAlign: 'center', padding: '32px 20px', background: 'rgba(255,255,255,0.04)', borderRadius: 16, border: '1px solid rgba(255,255,255,0.07)' }}>
              <div style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: 52, fontWeight: 800, color: '#60a5fa', letterSpacing: '-2px', lineHeight: 1, marginBottom: 10 }}>
                <CountUp target={s.num} suffix={s.suffix} start={started} decimals={s.decimals || 0} />
              </div>
              <div style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: 15, fontWeight: 700, color: 'white', marginBottom: 6 }}>{s.label}</div>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.35)', lineHeight: 1.5 }}>{s.sub}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
